import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestfulService } from '../rest/restful';
import { RestProvider, RestService } from '../rest/rest.service';

@Injectable()
export class MediaAssetsService extends RestfulService<Models.MediaAsset> {

  constructor(private restService: RestService) {
    super(Models.MediaAsset);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('media-assets');
  }

}
